/**
 * Slate Mobile Navigation Menu
 *
 */
( function( $ ) {

    "use strict";

	// Creates Var for Main (Header) Menu Hamburger Button.
	var $hamburger_menu_button = "<button class='menu-toggle' id='main-menu-toggle' title='Menu'><span class='menu-toggle__bar'></span><span class='menu-toggle__bar'></span><span class='menu-toggle__bar'></span></button>";

	// Creates Var for Menu Buttons (Which each expand a sub menu).
	var $expand_menu_button = "<button><span class='button-text'>Toggle Button</span></button>";

	// Selects elements that will have an "opened" appearance and a "closed"
	// appearance. Then adds a class of 'open' when that particular element
	// is clicked.
	$( ".site-header__branding" ).after( $hamburger_menu_button );
	$( document ).on( "click", "#main-menu-toggle", function() {
		$( this ).toggleClass( "open" );
		$( ".main-menu" ).toggleClass( "open" );
		$( ".main-menu > ul[role='menu']" ).toggleClass( "open" );
	});

	// If class '.main-menu__item--parent' exists (indicating there is a submenu)
	// Go ahead and add a Menu Button (created in the var above) to give the user the
	// capability to expand the submenu.
	if ( $( ".main-menu__item--parent" ) ) {
		$( ".main-menu__item--parent > a" ).after( $expand_menu_button );
	}

	// Add a class to the menu button when the user clicks it so that it has a
	// different appearance/style when clicked (indicating it has been activated)
	// and thus, the menu expanded.

	$( ".main-menu__item--parent button" ).on("click", function() {
		$( this ).toggleClass( "rotated_expand-button" );
		$( this ).siblings( "ul.main-menu__submenu" ).toggleClass( "expanded_main-menu__submenu" );
	});

	// On focus out event for last menu item in a sub-menu "set", check to see if menu has a button, and if it does, do nothing; otherwise if no button, let the natural order of "tabbing" change the focus from the child a to the child button take place and allow activation of child menu
	$( ".main-menu__submenu > li:last-of-type > a" ).on( "focusout", function () {
		// if li:last-of-type does have a button
		if ( $( this ).closest( "li" ).has( "button" ).length ) {
		// (implied: do nothing on this particular focus change - i.e. do not toggle parent toggles)
			// if on focus change FROM button (which is the next natural option)
			$( this ).closest( "li" ).children( "button" ).on( "focusout", function () {
				// if this button (that we changed the focus from) HAS a class of "rotated_expand-button"
				if ( $( this ).hasClass( "rotated_expand-button" ) ) {
					// Do nothing
				// if this button (that we changed the focus from) does NOT HAVE a class of "rotated_expand-button"
				} else {
					// toggle parent elements' respective classes to "close" the immediate menu
					var expandedMainMenuSubmenu = $( this ).closest( ".expanded_main-menu__submenu" );
					var expandedMainMenuSubmenuButton = $( this ).closest( ".expanded_main-menu__submenu" ).siblings( "button.rotated_expand-button" );
					$( expandedMainMenuSubmenu ).toggleClass( "expanded_main-menu__submenu" );
					$( expandedMainMenuSubmenuButton ).toggleClass( "rotated_expand-button" );
				}
			});
		// if li:last-of-type does not have a button
		} else {
			// find the immediate parent toggles and toggle them (to close menu and deactivate rotated menu button)
			var expandedMainMenuSubmenu = $( this ).closest( ".expanded_main-menu__submenu" );
			var expandedMainMenuSubmenuButton = $( this ).closest( ".expanded_main-menu__submenu" ).siblings( "button.rotated_expand-button" );
			$( expandedMainMenuSubmenu ).toggleClass( "expanded_main-menu__submenu" );
			$( expandedMainMenuSubmenuButton ).toggleClass( "rotated_expand-button" );
		}
		// and if the focus happens to change to the next top-level parent, close prev menu
		$( this ).closest( "li.toplevel" ).next().children( "a" ).on( "focusin", function() {
			var previousSiblingMainMenuSubmenu = $( this ).closest( "li.toplevel" ).prev( "li.toplevel" ).children( "ul.expanded_main-menu__submenu" );
			var previousSiblingMainMenuSubmenuButton = $( this ).closest( "li.toplevel" ).prev( "li.toplevel" ).children( "button.rotated_expand-button" );
			$( previousSiblingMainMenuSubmenu ).toggleClass( "expanded_main-menu__submenu" );
			$( previousSiblingMainMenuSubmenuButton ).toggleClass( "rotated_expand-button" );
		});
	});
})( jQuery );

// Adds a "tabindex" attribute to what "should be tab-able" elements -- OPTIONAL
// This isn't necessary IF tabindex attribute doesn't contribute to some sort of solution for FF and Safari tabbing issues; caused by those respective vendors, but not necessarily the markup.
jQuery( function() {
	var tabIndexEls = $( "ul[role='menu']" ).find( "li > a" );
	$( tabIndexEls ).each(function( index ) {
	  $( this ).attr( "tabindex", 0 );
	});
});
